import axios from 'axios';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarResolucion = ({ refresh }) => {
  const [resoluciones, setResoluciones] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get(`/api/resolucion/listbyenteid/${id}`);
      
      if (data.ok && Array.isArray(data.resolucionEntes)) {
        const resolucionesProcesadas = data.resolucionEntes.map((resolucion) => ({
          ...resolucion,
          nombreEnteconformador: resolucion.enteObjectId?.nombreEnteconformador || "Ente no disponible",
          coddaneEnteconformador: resolucion.enteObjectId?.coddaneEnteconformador || "Dane no disponible",
          nitEnteconformador: resolucion.enteObjectId?.nitEnteconformador || "Nit no disponible",
          fechaResolucion: resolucion.fechaResolucionEnte
            ? new Date(resolucion.fechaResolucionEnte).toLocaleDateString('es-CO')
            : 'Fecha no disponible',
          funciones: (
            <div className="d-flex gap-2">
              <button
                className="btn btn-warning"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/enteconformador/resoluciones/editar/${resolucion._id}`)}
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              <button
                className="btn btn-danger"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => deleteResolucion(resolucion._id)}
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          ),
        }));

        setResoluciones(resolucionesProcesadas.reverse());
      } else {
        console.error("Respuesta inválida al obtener resoluciones.");
      }
    } catch (error) {
      console.error("Error al cargar las resoluciones:", error);
    }
    // eslint-disable-next-line
  }, [navigate, id]);

  const deleteResolucion = async (id) => {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¡No podrá revertir este proceso!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { data } = await axios.delete(`/api/resolucion/${id}`);
          if (data.ok) {
            getData();
            Swal.fire({
              icon: 'success',
              title: data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            Swal.fire('Error', 'No se pudo eliminar la resolución.', 'error');
          }
        } catch (error) {
          console.error('Error al eliminar la resolución:', error);
          Swal.fire('Error', 'No se pudo eliminar la resolución.', 'error');
        }
      }
    });
  };

  useEffect(() => {
    getData();
  }, [getData, refresh]);

  const columns = useMemo(() => [
    { Header: 'Código', accessor: 'codResolucionEnte' },
    { Header: 'Fecha', accessor: 'fechaResolucion' },
    { Header: 'Tipo', accessor: 'tipoResolucionEnte' },  // corregido
    { Header: 'Nit Ente', accessor: 'nitEnteconformador' },
    { Header: 'Dane Ente', accessor: 'coddaneEnteconformador' },
    { Header: 'Ente Conformador', accessor: 'nombreEnteconformador' },
    { accessor: 'funciones' },
  ], []);

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <div className="d-flex align-items-center mb-3">
        <button
          style={{ marginTop: '24px', marginLeft: '32px' }}
          className="btn btn-outline-dark rounded-pill shadow-sm px-3 d-flex align-items-center gap-2 me-3"
          onClick={() => navigate(-1)}
          title="Regresar"
        >
          <i className="fa-solid fa-arrow-rotate-left"></i>
          <span>Volver</span>
        </button>

        <h1 className="text-center flex-grow-1 m-0">Listado de Resoluciones</h1>
      </div>

      {resoluciones.length > 0 ? (
        <DataTable columns={columns} data={resoluciones} />
      ) : (
        <p>No se encontraron resoluciones o está cargando...</p>
      )}
    </div>
  );
};

export default ListarResolucion;
